











































































































































































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import SearchBar from '@/pages/search/components/search-bar.vue';
import { SearchService } from '@/services/search-service';
import SearchResultCategory from '@/pages/search/components/search-result-category.vue';
import { ApiUtils } from '@/common/ApiUtils';
import { Product, SearchResults } from '@/api';

@Component({
	components: { SearchResultCategory },
})
export default class SearchResultsComponent extends Vue {
	public rid: number = Math.random();

	@Prop({ default: false })
	public inline!: boolean;

	@Prop({ required: true })
	public searchValue!: string;

	public hasSearched: boolean = false;
	public loading: boolean = false;

	public searchResults: SearchResults = {};
	public searchError?: string | null = null;

	private readonly searchService: SearchService = new SearchService();

	public mounted() {
		const searchValue = this.$route?.query?.q?.toString() ?? '';

		this.submitSearch(searchValue);
	}

	public getShowMoreRoute(name: string) {
		return { name, query: { search: this.searchValue } };
	}

	public clearSearch(): void {
		this.searchResults = {};
		this.loading = false;
		this.hasSearched = false;
	}

	public submitSearch(searchValue?: string, doReload: boolean = true): void {
		if (searchValue == null) {
			const searchBar = <SearchBar>(this.$parent?.$refs.searchBar ?? this.$refs.searcBar);
			searchValue = searchBar.searchValue;
		}

		if (!searchValue?.trim().length) return;

		if (this.$route.query?.q !== searchValue && doReload) {
			this.$router.push({ name: 'home', query: { q: searchValue } });
		}
		this.doSearch(searchValue);
	}

	private doSearch(searchValue: string): void {
		this.loading = true;
		this.hasSearched = true;
		this.searchError = null;

		this.onHasSearched();

		this.searchService
			.search(searchValue)
			.then(results => {
				this.searchResults = results;
				this.rid = Math.random();

				this.onHasLoadedResults();

				this.loading = false;
			})
			.catch(ex => {
				const error = ApiUtils.handleApiError(
					ex,
					`An error occurred searching for '${searchValue}'`,
				);
				this.loading = false;
				this.searchError = error.errorMessage;
			});
	}

	public hasSearchResults(): boolean {
		return !!(
			this.searchResults?.orgs?.length ||
			this.searchResults?.sites?.length ||
			this.searchResults?.products?.length ||
			this.searchResults?.users?.length ||
			this.searchResults?.transceivers?.length ||
			this.searchResults?.sensors?.length ||
			this.searchResults?.gateways?.length ||
			this.searchResults?.nodes?.length
		);
	}

	public limit<T>(arr: T[]): T[] {
		return arr?.slice(0, Math.min(arr.length, 10));
	}

	public navigateTo(route: { name: string; params?: any }, newTab?: boolean): void {
		if (newTab) {
			window.open(this.$router.resolve(route).href, '_blank');
		} else {
			if (this.$router.currentRoute.name === route.name) {
				window.open(this.$router.resolve(route).href, '_self');
				return;
			}
			this.$router.push(route);
			this.clearSearch();
		}
	}

	public navigateToOrg(orgId: number, newTab?: boolean): void {
		this.navigateTo({ name: 'organisations.view', params: { orgId } }, newTab);
	}

	public navigateToSite(siteId: number, newTab?: boolean): void {
		this.navigateTo({ name: 'sites.view', params: { siteId } }, newTab);
	}

	public navigateToProduct(product: Product, newTab?: boolean): void {
		this.navigateTo(
			{ name: `products.${product.type}.view`, params: { productId: product.id } },
			newTab,
		);
	}

	public navigateToUser(userId: number, newTab?: boolean): void {
		this.navigateTo({ name: 'users.view', params: { userId } }, newTab);
	}

	public navigateToTransceiver(transceiverId: number, newTab?: boolean): void {
		this.navigateTo({ name: 'transceivers.view', params: { transceiverId } }, newTab);
	}

	public navigateToSensor(sensorId: number, newTab?: boolean): void {
		this.navigateTo({ name: 'sensors.view', params: { sensorId } }, newTab);
	}

	public navigateToGateway(gatewayId: number, newTab?: boolean): void {
		this.navigateTo({ name: 'gateways.view', params: { gatewayId } }, newTab);
	}

	public navigateToNode(nodeId: number, newTab?: boolean): void {
		this.navigateTo({ name: 'nodes.view', params: { nodeId } }, newTab);
	}

	@Emit('hasSearched')
	public onHasSearched(): boolean {
		return this.hasSearched;
	}

	@Emit('hasLoadedResults')
	public onHasLoadedResults(): SearchResults {
		return this.searchResults;
	}
}
